module.exports = __webpack_public_path__ + "static/assets/5debaf78c4f9d743cc3a64b6c3bf9d82.jpg";